import { styled } from '@mui/material'

export default styled('form')(({ theme }) => ({
  fontFamily: '"Outfit", Arial, sans-serif',
  width: '100%',
  backgroundColor: 'white',
  padding: '20px',
  [theme.breakpoints.not('xs')]: {
    border: '1px solid #DFE1E7',
    borderRadius: '6px',
    padding: '40px 75px',
    marginTop: '46px',
    width: '635px',
    right: 2,
    top: 0
  }
}))
